import cdeSeal from "@/public/images/cde-seal.png";

const BANNER_HEIGHT = 76;

const DashboardBranding = () => {
  return (
    <div
      className="d-flex align-items-center"
      style={{
        height: BANNER_HEIGHT,
        gap: "10px",
        margin: "-1.5rem -1.5rem 1.5rem -1.5rem",
        padding: "0 2rem",
        backgroundColor: "#eef4fa",
        borderBottom: "1px solid #dbe2ea",
      }}
    >
      <img
        src={cdeSeal}
        alt="California Department of Education"
        width={64}
        height={64}
        style={{ borderRadius: "50%", objectFit: "cover" }}
      />
      <span
        style={{
          fontWeight: 600,
          fontSize: "15px",
          color: "#1e293b",
          letterSpacing: "0.2px",
        }}
      >
        California Department of Education
      </span>
    </div>
  );
};

export default DashboardBranding;
